import { render, staticRenderFns } from "./dialogHint.vue?vue&type=template&id=64423d02&scoped=true"
import script from "./dialogHint.vue?vue&type=script&lang=js"
export * from "./dialogHint.vue?vue&type=script&lang=js"
import style0 from "./dialogHint.vue?vue&type=style&index=0&id=64423d02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64423d02",
  null
  
)

export default component.exports